import { Injectable } from '@angular/core';
import { global } from '../../models/global';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import 'rxjs/add/Observable/throw';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { debounce } from 'rxjs/operator/debounce';
import { DebugElement } from '@angular/core/src/debug/debug_node';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import { CropDetails } from '../../Models/AdminRights/crop-details';
import { ListItem } from 'ng-multiselect-dropdown/multiselect.model';
import { ReminderEmail } from '../../Models/AdminRights/reminder-email';


@Injectable({
  providedIn: 'root'
})
export class AdminRightsService {
  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  productConfig(user: any): Observable<any> {
    let _body = {
      "userId": user,
      "RoleCode": ''
    }
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/AdminRights/ProductConfig",
      headers: headers,
      body: _body
    })

    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });

  }
  getCropDetails(userID: string, roleCode: string): Observable<any> {
    let url = this.ROOT_URL + '/api/AdminRights/CropDetails';
    let body = { "userID": userID, "roleCode": roleCode };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body
      //body: JSON.stringify(body)
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  updateCropDetails(item: any, userId: string, roleId: string): Observable<any> {
    let m_model = { 'model': item };
    let m_userid = { 'userId': userId };
    let m_roleId = { 'roleId': roleId };
    let url = this.ROOT_URL + '/api/AdminRights/UpdateCropDetails';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: { model: m_model, userid: m_userid, roleid: m_roleId },
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  getPackSizeDetails(userID: string, roleCode: string): Observable<any> {
    let url = this.ROOT_URL + '/api/AdminRights/PackSizeDetails';
    let body = { "userID": userID, "roleCode": roleCode };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body
      //body: JSON.stringify(body)
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  updatePackSizeDetails(item: any, userId: string, roleId: string): Observable<any> {
    let m_model = { 'model': item };
    let m_userid = { 'userId': userId };
    let m_roleId = { 'roleId': roleId };
    let url = this.ROOT_URL + '/api/AdminRights/UpdatePackSizeDetails';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: { model: m_model, userid: m_userid, roleid: m_roleId },
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }



  TimelineSettingSave(timeline:any): Observable<any>
  {   
    let url = this.ROOT_URL + '/api/AdminRights/TimelineSettingSave';    
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: timeline
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }




  //   getReminderEmail(reminderEmail : ReminderEmail): Observable<any> {
  //     let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
  //     let _body ={model: { "UserId":UserId}};
  //     let requestoptions: RequestOptions = new RequestOptions({
  //         method: 'POST',
  //         url: this.ROOT_URL+'/api/AdminRights/ReminderEmailConfig',
  //         headers: headers,
  //         body: _body
  //     })
  //     return this.http.request(new Request(requestoptions))
  //         .map((res: Response) => {
  //             return res.json();
  //         });
  // }

    getReminderEmail(UserId:any): Observable<any> {
      let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
      let _body ={"userId":UserId};
      let requestoptions: RequestOptions = new RequestOptions({
          method: 'POST',
          url: this.ROOT_URL+'/api/AdminRights/GetReminderEmailConfigData',
          headers: headers,
          body: _body
      })
      return this.http.request(new Request(requestoptions))
          .map((res: Response) => {
              return res.json();
          });
  }


  //postgetReminderEmail(FirstDate: any, SecondDate: any): Observable<any> {
  postgetReminderEmail(FormData: any): Observable<any> {
    let _body = {
        'LoggedInUser': localStorage.getItem('dsu_userId'),
        'RequirementSubmissionRem1': FormData.value.AnnualReminderFirstDate,
        'RequirementSubmissionRem2': FormData.value.AnnualReminderSecondDate,
        'RequirementApprovalRem1': FormData.value.ApprovalReminderFirstDate,
        'RequirementApprovalRem2': FormData.value.ApprovalReminderSecondDate,
        'CostApprovalRem1': FormData.value.CostReminderFirstDate,
        'CostApprovalRem2': FormData.value.CostReminderSecondDate,
        'MaterialAllocationRem1': FormData.value.MaterialReminderFirstDate,
        'MaterialAllocationRem2': FormData.value.MaterialReminderSecondDate,
        'DispatchToSDRem1': FormData.value.DispatchReminderFirstDate,
        'DispatchToSDRem2': FormData.value.DispatchReminderSecondDate,
        'DispatchToFieldTeamRem1': FormData.value.DispatchToFTReminderFirstDate,
        'DispatchToFieldTeamRem2': FormData.value.DispatchToFTReminderSecondDate,
    };
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token')});

    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + '/api/AdminRights/ReminderEmailConfig',
      headers: headers,
      body: _body
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }
  updateProductConfiguration(productConfigObj: any,user: any): Observable<any> {
    let _body = { "Obj": { "productList": productConfigObj, "userId": user } };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/AdminRights/UpdateProductConfig",
      headers: headers,
      body: _body
    })

    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      }, error => {
      });
  }

  TimelineSettingView(userId: string): Observable<any> {        
    let url = this.ROOT_URL + '/api/AdminRights/TimelineSettingView?userId=' + userId;
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: url,
      headers: headers,
    })
    let response =  this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
    return response;
  }
  TimelineSettingUpdate(timeline:any): Observable<any>
  {
    let url = this.ROOT_URL + '/api/AdminRights/TimelineSettingUpdate';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: timeline
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }
  TimelineNotification(): Observable<any> {        
    let url = this.ROOT_URL + '/api/AdminRights/TimelineNotification';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8' });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'GET',
      url: url,
      headers: headers,
    })
    let response =  this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
    return response;
  }

}
